var styleDataHash = "259b3f2e";
const injectCss = () => {
  var css = `._2zlH9,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.og-0j{width:100%}[dir] .og-0j{margin:8px auto 0}.og-0j .qpNwI{height:1px}[dir] .og-0j .qpNwI{background-color:var(--ricos-settings-dividers-color,rgba(51,51,51,.2))}@supports not (contain:inline-size){@media only screen and (max-width:640px){.og-0j .qpNwI{width:100%}[dir] .og-0j .qpNwI{margin:0}}}@container (width < 640px){.og-0j .qpNwI{width:100%}[dir] .og-0j .qpNwI{margin:0}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var list_item_section_default = {
  "fontElementMap": "_2zlH9",
  "whitespace": "og-0j",
  "divider": "qpNwI"
};
export {
  list_item_section_default as default,
  injectCss
};
//# sourceMappingURL=list-item-section-scss.js.map
